import { Grid } from '@mui/material';
import * as React from 'react';
import { appInsights } from '../../AppInsights';
import styles from './Hocr.module.scss';

interface IDocumenthOcrProps {
    hOcrString: string;
    title: string;
}
interface IDocumenthOcrState { }

interface hOrc {
    imgUrl: string;
    pageData: any;
}

export class DocumenthOcr extends React.Component<IDocumenthOcrProps, IDocumenthOcrState> {

    public render() {
        return (
            <>
                {this.mark()}
            </>
        );
    }


    private mark() {
        return this.getSrc().map((d, i) => {
            return (
                <Grid container spacing={1} key={i}>
                    <Grid item xs={6}>
                        <div className={styles.document}>
                            <div className={styles.pageInfo}>
                                {this.generateImage(d.imgUrl, i)}
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <div className={styles.documentInfo}>
                            <div className={styles.pageNumber}>Page {i + 1}</div>
                            {
                                this.generateLines(d.pageData, i)
                            }
                        </div>
                    </Grid>
                </Grid>);
        })
    }

    private generateWords(d: any) {
        var word = d.getElementsByClassName('ocrx_word');
        let words = [];
        for (let i = 0; i < word.length; i++) {
            words.push(<div>{word[i].textContent}</div>);
        }
        return words;
    }

    private generateLines(d: any, key: number) {
        var line = d.getElementsByClassName('ocr_line');
        let lines = [];
        for (let i = 0; i < line.length; i++) {
            // this.generateWords(line[i]);
            lines.push(<div key={i + key}>{line[i].textContent}</div>);
        }
        return lines;
    }

    private getSrc(): hOrc[] {

        var imageUrls: hOrc[] = [];

        try {
            var htmlObject = document.createElement('div');
            htmlObject.innerHTML = this.props.hOcrString;
            var htmlString = htmlObject.getElementsByClassName('ocr_page');
            var title = htmlString[0].attributes.getNamedItem('title') || new Attr;
            for (let index = 0; index < htmlString.length; index++) {
                const element = htmlString[index];
                var title = element.attributes.getNamedItem('title') || new Attr;
                var start_pos = title.value.indexOf('"') + 1;
                var end_pos = title.value.indexOf('"', start_pos);
                var text_to_get = title.value.substring(start_pos, end_pos);
                imageUrls.push({
                    imgUrl: text_to_get,
                    pageData: htmlString[index]
                });
            }
        } catch (e) {
            let err = new Error("Get document image (Document hOcr): " + e);
            appInsights.trackException({
                exception: err,
                severityLevel: 3
            });
            console.error(err);
        }
        return imageUrls;
    }

    private generateImage(src: string, index: number) {
        return <img src={src} key={index} alt={this.props.title} />;
    }
}